var _style, _defs, _g, _defs2, _g2, _defs3, _g3, _g4, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDealerPinSelected2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 35 49",
    style: {
      enableBackground: "new 0 0 35 49"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;}\n\t.st1{display:inline;}\n\t.st2{display:inline;clip-path:url(#SVGID_2_);}\n\t.st3{fill:#005996;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{display:inline;clip-path:url(#SVGID_4_);}\n\t.st6{clip-path:url(#SVGID_6_);}\n\t.st7{display:none;fill:#005996;}\n")), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    y: 0.5,
    width: 35,
    height: 48
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M17.5,0.5c-4.6,0-9.1,1.8-12.4,5.1C1.8,8.9,0,13.3,0,18c0,9.7,17.5,30.6,17.5,30.6S35,27.6,35,18 c0-2.3-0.5-4.6-1.3-6.7c-0.9-2.1-2.2-4.1-3.8-5.7c-1.6-1.6-3.6-2.9-5.7-3.8C22.1,0.9,19.8,0.5,17.5,0.5z M17.5,32.6 c-2.9,0-5.7-0.9-8.2-2.5c-2.4-1.6-4.3-3.9-5.4-6.6c-1.1-2.7-1.4-5.6-0.8-8.5c0.6-2.8,2-5.5,4-7.5c2.1-2.1,4.7-3.5,7.5-4 c2.8-0.6,5.8-0.3,8.5,0.8c2.7,1.1,5,3,6.6,5.4c1.6,2.4,2.5,5.3,2.5,8.2c0,1.9-0.4,3.8-1.1,5.6c-0.7,1.8-1.8,3.4-3.2,4.8 c-1.4,1.4-3,2.4-4.8,3.2C21.3,32.3,19.4,32.6,17.5,32.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M17.5,3.3C13.5,3.3,9.7,4.9,7,7.6c-2.8,2.8-4.4,6.6-4.4,10.5c0,8.2,14.9,26,14.9,26s14.9-17.8,14.9-26 c0-2-0.4-3.9-1.1-5.7C30.5,10.7,29.4,9,28,7.6c-1.4-1.4-3-2.5-4.8-3.2C21.4,3.7,19.4,3.3,17.5,3.3z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    y: 0.5,
    width: 35,
    height: 48
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M17.5,0.5c-4.6,0-9.1,1.8-12.4,5.1C1.8,8.9,0,13.3,0,18c0,9.7,17.5,30.6,17.5,30.6S35,27.6,35,18 c0-2.3-0.5-4.6-1.3-6.7c-0.9-2.1-2.2-4.1-3.8-5.7c-1.6-1.6-3.6-2.9-5.7-3.8C22.1,0.9,19.8,0.5,17.5,0.5z M17.5,32.6 c-2.9,0-5.7-0.9-8.2-2.5c-2.4-1.6-4.3-3.9-5.4-6.6c-1.1-2.7-1.4-5.6-0.8-8.5c0.6-2.8,2-5.5,4-7.5c2.1-2.1,4.7-3.5,7.5-4 c2.8-0.6,5.8-0.3,8.5,0.8c2.7,1.1,5,3,6.6,5.4c1.6,2.4,2.5,5.3,2.5,8.2c0,1.9-0.4,3.8-1.1,5.6c-0.7,1.8-1.8,3.4-3.2,4.8 c-1.4,1.4-3,2.4-4.8,3.2C21.3,32.3,19.4,32.6,17.5,32.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M17.5,0.5c-4.6,0-9.1,1.8-12.4,5.1C1.8,8.9,0,13.3,0,18c0,9.7,17.5,30.6,17.5,30.6S35,27.6,35,18 c0-2.3-0.5-4.6-1.3-6.7c-0.9-2.1-2.2-4.1-3.8-5.7c-1.6-1.6-3.6-2.9-5.7-3.8C22.1,0.9,19.8,0.5,17.5,0.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M17.5,4.1c-3.7,0-7.3,1.5-9.9,4.1c-2.6,2.6-4.1,6.2-4.1,9.9c0,7.8,14.1,24.5,14.1,24.5s14.1-16.8,14.1-24.5 c0-1.8-0.4-3.7-1.1-5.4c-0.7-1.7-1.7-3.3-3-4.6c-1.3-1.3-2.9-2.3-4.6-3C21.2,4.5,19.3,4.1,17.5,4.1z"
  })))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    y: 0.5,
    width: 35,
    height: 48
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "st6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M17.5,0.5c-4.6,0-9.1,1.8-12.4,5.1C1.8,8.9,0,13.3,0,18c0,9.7,17.5,30.6,17.5,30.6S35,27.6,35,18 c0-2.3-0.5-4.6-1.3-6.7c-0.9-2.1-2.2-4.1-3.8-5.7c-1.6-1.6-3.6-2.9-5.7-3.8C22.1,0.9,19.8,0.5,17.5,0.5z M17.5,32.6 c-2.9,0-5.7-0.9-8.2-2.5c-2.4-1.6-4.3-3.9-5.4-6.6c-1.1-2.7-1.4-5.6-0.8-8.5c0.6-2.8,2-5.5,4-7.5c2.1-2.1,4.7-3.5,7.5-4 c2.8-0.6,5.8-0.3,8.5,0.8c2.7,1.1,5,3,6.6,5.4c1.6,2.4,2.5,5.3,2.5,8.2c0,1.9-0.4,3.8-1.1,5.6c-0.7,1.8-1.8,3.4-3.2,4.8 c-1.4,1.4-3,2.4-4.8,3.2C21.3,32.3,19.4,32.6,17.5,32.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M33.7,11.3c-0.9-2.1-2.2-4.1-3.8-5.7c-1.6-1.6-3.6-2.9-5.7-3.8c-2.1-0.9-4.4-1.3-6.7-1.3 c-4.6,0-9.1,1.8-12.4,5.1C1.8,8.9,0,13.3,0,18c0,9.7,17.5,30.5,17.5,30.5S35,27.6,35,18C35,15.7,34.5,13.4,33.7,11.3z M17.5,42.7 c0,0-14.1-16.8-14.1-24.5c0-3.7,1.5-7.3,4.1-9.9c2.6-2.6,6.2-4.1,9.9-4.1c1.8,0,3.7,0.4,5.4,1.1c1.7,0.7,3.3,1.7,4.6,3 c1.3,1.3,2.3,2.9,3,4.6c0.7,1.7,1.1,3.5,1.1,5.4C31.6,25.9,17.5,42.7,17.5,42.7z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Camada_2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M19.9,16l-2.4-8l-2.4,8H7.5l6.2,4.4L11.3,28l6.2-4.7l6.2,4.7l-2.4-7.6l6.2-4.4H19.9z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDealerPinSelected2);
export default __webpack_public_path__ + "static/media/dealer-pin-selected-2.917842225c395c707e670403c1fc8c55.svg";
export { ForwardRef as ReactComponent };